var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal custom",
      attrs: { id: "cw_confirm", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog request-modal" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function ($event) {
                    return _vm.reset()
                  },
                },
              },
              [_vm._v("×")]
            ),
            _vm._m(0),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn emergo-blue-button",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.reset()
                  },
                },
              },
              [_vm._v("OK")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p-confirm" }, [
      _c("div", [
        _c("img", {
          staticClass: "check_img",
          attrs: {
            src: "/static/images/icons/check_icon.svg",
            alt: "check-icon",
          },
        }),
        _c("h3", { staticClass: "confirm_title" }, [
          _vm._v("Thanks for your request!"),
        ]),
      ]),
      _c("div", [_vm._v("Our Sales Team will contact you soon.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }